[
  {
    "schemaVersion": 1,
    "slug": "2026-11-04",
    "publishedAt": "2026-11-04",
    "level": "HSK1",
    "theme": "City life",
    "title": "城市公园开新花园",
    "titlePinyin": "Chéngshì gōngyuán kāi xīn huāyuán",
    "dek": "A small garden shared by people and insects.",
    "image": "🌳",
    "imageAlt": "A park with green trees, flowers, and a bee",
    "summary": [
      { "hanzi": "今天，城市公园开放了一个新花园。", "pinyin": "Jīntiān, chéngshì gōngyuán kāifàng le yí ge xīn huāyuán." },
      { "hanzi": "花园里有很多花，也有给蜜蜂喝水的小地方。", "pinyin": "Huāyuán lǐ yǒu hěn duō huā, yě yǒu gěi mìfēng hē shuǐ de xiǎo dìfang." },
      { "hanzi": "工作人员说，他们希望更多人来这里认识自然。", "pinyin": "Gōngzuò rényuán shuō, tāmen xīwàng gèng duō rén lái zhèlǐ rènshi zìrán." }
    ],
    "vocabulary": [
      { "hanzi": "公园", "pinyin": "gōngyuán", "meaning": "park", "image": "🌳", "imageAlt": "Trees" },
      { "hanzi": "花", "pinyin": "huā", "meaning": "flower", "image": "🌼", "imageAlt": "A yellow flower" },
      { "hanzi": "蜜蜂", "pinyin": "mìfēng", "meaning": "bee", "image": "🐝", "imageAlt": "A bee" },
      { "hanzi": "水", "pinyin": "shuǐ", "meaning": "water", "image": "💧", "imageAlt": "A drop of water" }
    ],
    "exercises": [
      { "id": "park-meaning", "type": "choice", "prompt": "Which image means 公园 (gōngyuán)?", "options": ["🌳", "🚆", "🍚"], "answer": "🌳", "explanation": "公园 (gōngyuán) means “park”." },
      { "id": "garden-fact", "type": "choice", "prompt": "What is in the new garden?", "options": ["很多花", "很多车", "很多雪"], "answer": "很多花", "explanation": "The article says: 花园里有很多花 — there are many flowers in the garden." },
      { "id": "nature-match", "type": "match", "prompt": "Match each Hanzi word to its Pinyin", "pairs": [{ "left": "花", "right": "huā" }, { "left": "水", "right": "shuǐ" }, { "left": "蜜蜂", "right": "mìfēng" }] },
      { "id": "garden-order", "type": "order", "prompt": "Put the words in the correct order", "parts": ["一个", "公园", "有", "新花园"], "answer": ["公园", "有", "一个", "新花园"], "explanation": "The basic Chinese word order is: subject + verb + quantity + noun." }
    ],
    "source": { "name": "Example source: city park notice", "url": "https://example.com/city-park-notice", "accessedAt": "2026-11-04" },
    "editorialNote": "This is an original example summary written for language learning. It is not a translation or copy of the source article."
  },
  {
    "schemaVersion": 1,
    "slug": "2026-11-03",
    "publishedAt": "2026-11-03",
    "level": "HSK1",
    "theme": "Science and weather",
    "title": "学生一起看月亮",
    "titlePinyin": "Xuésheng yìqǐ kàn yuèliang",
    "dek": "An evening science activity invites students to look up at the sky.",
    "image": "🌙",
    "imageAlt": "The moon and a telescope under the night sky",
    "summary": [
      { "hanzi": "昨天晚上，一所学校举行了看月亮的活动。", "pinyin": "Zuótiān wǎnshang, yì suǒ xuéxiào jǔxíng le kàn yuèliang de huódòng." },
      { "hanzi": "学生用望远镜看天空。", "pinyin": "Xuésheng yòng wàngyuǎnjìng kàn tiānkōng." },
      { "hanzi": "老师说，天气很好，月亮非常清楚。", "pinyin": "Lǎoshī shuō, tiānqì hěn hǎo, yuèliang fēicháng qīngchu." }
    ],
    "vocabulary": [
      { "hanzi": "月亮", "pinyin": "yuèliang", "meaning": "moon", "image": "🌙", "imageAlt": "A crescent moon" },
      { "hanzi": "学生", "pinyin": "xuésheng", "meaning": "student", "image": "🧑‍🎓", "imageAlt": "A student" },
      { "hanzi": "学校", "pinyin": "xuéxiào", "meaning": "school", "image": "🏫", "imageAlt": "A school" },
      { "hanzi": "天空", "pinyin": "tiānkōng", "meaning": "sky", "image": "🌌", "imageAlt": "A starry sky" }
    ],
    "exercises": [
      { "id": "moon-meaning", "type": "choice", "prompt": "Which image means 月亮 (yuèliang)?", "options": ["🌙", "☀️", "🌳"], "answer": "🌙", "explanation": "月亮 (yuèliang) means “moon”." },
      { "id": "weather-fact", "type": "choice", "prompt": "What was the weather like last night?", "options": ["很好", "很冷", "下雨"], "answer": "很好", "explanation": "The teacher says: 天气很好 — the weather was very good." },
      { "id": "sky-match", "type": "match", "prompt": "Match each Hanzi word to its Pinyin", "pairs": [{ "left": "学生", "right": "xuésheng" }, { "left": "学校", "right": "xuéxiào" }, { "left": "天空", "right": "tiānkōng" }] },
      { "id": "moon-order", "type": "order", "prompt": "Put the words in the correct order", "parts": ["看", "学生", "月亮"], "answer": ["学生", "看", "月亮"], "explanation": "The basic Chinese word order is: subject + verb + object." }
    ],
    "source": { "name": "Example source: school event notice", "url": "https://example.com/school-moon-event", "accessedAt": "2026-11-03" },
    "editorialNote": "This is an original example summary written for language learning. It is not a translation or copy of the source article."
  }
]
